import { render, staticRenderFns } from "./TeachingStudio.vue?vue&type=template&id=09e06a51&scoped=true"
import script from "./TeachingStudio.vue?vue&type=script&lang=js"
export * from "./TeachingStudio.vue?vue&type=script&lang=js"
import style0 from "./TeachingStudio.vue?vue&type=style&index=0&id=09e06a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e06a51",
  null
  
)

export default component.exports